import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';
import { SpecProjectList } from '../components/features/spec-requirements/SpecProjectList.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 要件定義の入口。成果物のある案件を一覧で出し、案件ごとのページへ送る
 * @graph-connects SpecProjectList [calls] 案件一覧の描画
 */
export const Route = createFileRoute('/projects/spec/')({
  component: SpecRequirementsPage,
});

/** @graph-connects SpecProjectList [calls] 案件一覧の描画 */
function SpecRequirementsPage() {
  return (
    <ProtectedRoute pageKey="specRequirements">
      <SpecProjectList />
    </ProtectedRoute>
  );
}
